module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-message-fade"
    },
    on: {
      "after-leave": _vm.handleAfterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    class: [
      'el-message',
      'rt-message',
      _vm.type && !_vm.iconClass ? ("el-message--" + _vm.type) : '',
      _vm.center ? 'is-center' : '',
      _vm.showClose ? 'is-closable' : '',
      _vm.customClass
    ],
    style: (_vm.positionStyle),
    attrs: {
      "role": "alert"
    },
    on: {
      "mouseenter": _vm.clearTimer,
      "mouseleave": _vm.startTimer
    }
  }, [_c('rt-icon', {
    class: ("rt-message-" + _vm.type),
    attrs: {
      "name": ("rt-base-message-" + _vm.type),
      "size": "32"
    }
  }), _vm._v(" "), _vm._t("default", function() {
    return [(!_vm.dangerouslyUseHTMLString) ? _c('p', {
      staticClass: "el-message__content"
    }, [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")]) : _c('p', {
      staticClass: "el-message__content",
      domProps: {
        "innerHTML": _vm._s(_vm.message)
      }
    })]
  }), _vm._v(" "), (_vm.showClose) ? _c('rt-button', {
    staticClass: "rt-message-close",
    attrs: {
      "icon-name": "rt-base-close-x",
      "text": "",
      "icon-size": "16"
    },
    on: {
      "click": _vm.close
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99a34156"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/message/src/main.vue
// module id = 1539
// module chunks = 124